
export const DRIVER_STATEMENT_TYPE_ISOBAG = 1;
